module.exports = __webpack_public_path__ + "static/media/icon-workstyle.301a7fd0.svg";